(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.ucalgaryMenu = {
    isInitialized: false,
    attach: function (context) {
      if (this.isInitialized) {
        return;
      }
      this.isInitialized = true;

      // Store our key menu objects.
      var $menu = $('#uc-menu');
      var $hamburger = $('#hamburger', $menu);

      function updateDropdownHeight($dropdown) {
        if ($dropdown.length) {
          var dropdownHeight = 0;
          if ($dropdown.hasClass('tabbed')) {
            var $subMenu = $('> li:not(.menu-block-item)', $dropdown);
            // Find the tallest section of the tabbed dropdown.
            $subMenu.each(function (index) {
              // Left-hand tabs section.
              if (index === $subMenu.length - 1) {
                // Find height and top position of last tab for tabs height.
                var curTabsHeight = $(this).outerHeight(true) + $(this).position().top;
                if (curTabsHeight > dropdownHeight) {
                  dropdownHeight = curTabsHeight;
                }
              }
              // Right-hand links section.
              var $links = $('ul.level3.uc-submenu', this);
              var curLinksHeight = $links.outerHeight(true);
              // Need to factor in VISIBLE menu's top position for links height.
              if ($links.position()) {
                // The top value of this element accounts for the space that is
                // used by the overview link.
                curLinksHeight += parseInt($links.css('top'), 10);
              }
              if (curLinksHeight > dropdownHeight) {
                dropdownHeight = curLinksHeight;
              }
            });
          }
          else {
            dropdownHeight = $('div.uc-sublinks', $dropdown).outerHeight(true);
          }

          $dropdown.height(dropdownHeight);
        }
      }

      function isMenuOpen() {
        return $hamburger.hasClass('uc-menu-open');
      }

      function resetMenus() {
        // Reset any existing 'active' menus...
        $('.uc-active-path', $menu).removeClass('uc-active-path');
        $('.uc-active-link', $menu).removeClass('uc-active-link');
        $('.uc-active-link-submenu', $menu).removeClass('uc-active-link-submenu');
      }

      function resetMenuState() {
        // Reset any existing menus...
        resetMenus();
        // Reset user's current position.
        $('ul.level1.uc-menu', $menu).removeClass('uc-off-current-path');
        // Reset hamburger/menu state.
        $hamburger.removeClass('uc-menu-open uc-mobile-menu-open uc-desktop-menu-open');
      }

      function closeClickedMenu($clickedMenu) {
        $clickedMenu.removeClass('uc-active-link').parents('ul, li').removeClass('uc-active-path');
        $('.level2.uc-submenu', $menu).height(0); // Reset menu height.
      }

      function openClickedMenu($clickedMenu) {
        if (!isMenuOpen()) {
          $hamburger.trigger('click'); // Initiate open animation.
        }

        // Reset any existing menus...
        resetMenus();

        // ...and rebuild the display logic.
        $clickedMenu.addClass('uc-active-link')
          .children('ul').addClass('uc-active-link-submenu');
        $clickedMenu.parents('ul, li.children').addClass('uc-active-path');

        // Grab the dropdown height and trigger desktop dropdown menu animation.
        var $openMenu = $('ul.level2.uc-submenu', $clickedMenu);
        updateDropdownHeight($openMenu);
      }

      //
      // Menu state logic.
      //
      function toggleMenu($clickedMenu) {
        if ($clickedMenu.closest('ul').hasClass('uc-active-link-submenu') ||
          $clickedMenu.siblings().not('.uc-main-menu').hasClass('uc-active-link')) {
          // Digging deeper on mobile menu, or clicking tabs on desktop menu.
          openClickedMenu($clickedMenu);
        }
        else if ($('li[class*="uc-active"].uc-main-menu', $menu).length) {
          // Clicked main menu already open, so close it (impossible on mobile)!
          if ($clickedMenu.hasClass('uc-main-menu') &&
            ($clickedMenu.hasClass('uc-active-path') || $clickedMenu.hasClass('uc-active-link'))) {
            if (isMenuOpen()) {
              $hamburger.trigger('click'); // Initiate close animation.
            }
          }
          // Main menu other than clicked menu is open, so close it first...
          else {
            $('ul.level2.uc-submenu', $menu)
              .on('transitionend webkitTransitionEnd oTransitionEnd', function (event) {
                if (event.target === event.currentTarget) {
                  // ...and open the clicked menu.
                  openClickedMenu($clickedMenu);
                  // Remove event handler.
                  $('ul.level2.uc-submenu', $menu).off('transitionend webkitTransitionEnd oTransitionEnd');
                }
              });
            closeClickedMenu($('li[class*="uc-active"].uc-main-menu', $menu));
            openClickedMenu($clickedMenu);
          }
        }
        else {
          openClickedMenu($clickedMenu);
        }
        $('ul.level1.uc-menu', $menu).addClass('uc-off-current-path');
      }

      // We capture the focus and mousedown events below, but we need to
      // preventDefault on the click event to prevent a # being added to the url
      $('.uc-menu-wrapper li > a', $menu).on('click', function (event) {
        if ($(this).attr('href') === '#') {
          event.preventDefault();
        }
      });

      //
      // Main menu event handler.
      //
      $('.uc-menu-wrapper li > a', $menu).on('focus mousedown', function (event) {
        if ($(this).attr('href') === '#') {
          if ($(this).closest('li').hasClass('uc-active-link')) {
            // Tabbing backwards and hitting a new level 1 menu item.
            if (!$(this).closest('ul').is('.tabbed.level2')) {
              toggleMenu($(this).closest('li.children'));
            }
          }
          // Tabbing or clicking forward and hitting a level 1 or 2 item.
          // Skip for level 1/2 back items.
          else if (!$(this).closest('li').hasClass('uc-back')) {
            toggleMenu($(this).closest('li.children'));
          }
        }
        else {

          let lowerLevel = $(this).closest('ul').hasClass('level3') || $(this).closest('ul').hasClass('level4');
          let tabbed = $(this).closest('ul.level2').hasClass('tabbed');
          let activeTab = $(this).closest('li.uc-active-link:not(.uc-main-menu)').hasClass('uc-active-link');
          let active = $(this).closest('li.uc-active-link').hasClass('uc-active-link');

          if (!isMenuOpen()) {
            // If menu is closed and focus is happening on a lower level menu item,
            // then we know its being tabbed to backwards and needs multiple parents
            // to be clicked open in order.
            if (lowerLevel) {
              toggleMenu( $(this).parentsUntil('.level1.uc-submenu', 'li.children'));
              toggleMenu( $(this).parentsUntil('.level2.uc-submenu', 'li.children'));
            }
            // Otherwise we can just call the toggle as normal.
            else {
              toggleMenu($(this).closest('li.children'));
            }
          }
          else {
            // If we are tabbing backwards and hit a level 3 or level 4 menu item
            // that is on a different tab that is closed.
            if (tabbed && !activeTab && lowerLevel) {
              toggleMenu( $(this).parentsUntil('.level2.uc-submenu', 'li.children'));
            }
            // If we are tabbing backwards and hit an inactive level 2 non-tabbed
            // menu item.
            else if (!tabbed && !active) {
              toggleMenu($(this).closest('li.children'));
            }
          }
        }
        return false; // Prevent # in address bar
      });

      //
      // 'Back' links (for mobile).
      //
      $('li.uc-back > a').on('click', function () {
        // Use 'closest()' to support link in non-tabbed '.uc-sublinks' wrapper.
        $(this).closest('ul').removeClass('uc-active-link-submenu')
          .closest('li.children').removeClass('uc-active-link')
          .closest('ul').removeClass('uc-active-path').not('.level1').addClass('uc-active-link-submenu')
          .closest('li.children').removeClass('uc-active-path').addClass('uc-active-link')
          .parents('ul, li').addClass('uc-active-path');
        $('ul.level1.uc-menu', $menu).addClass('uc-off-current-path');
        return false; // Prevent # in address bar
      });

      //
      // Hamburger menu visibility/animation toggle.
      //
      $hamburger.on('click', function () {
        if (isMenuOpen()) {
          $('.uc-menu-wrapper', $menu).addClass('uc-menu-toggle');
          $('.uc-menu-wrapper, ul.level2.uc-submenu', $menu)
            .on('transitionend webkitTransitionEnd oTransitionEnd', function (event) {
              if (event.target === event.currentTarget) {
                $('.uc-menu-wrapper', $menu).removeClass('uc-menu-toggle');
                // Reset all menu settings after animation is complete
                // to prevent any weird flashes of default menu states.
                resetMenuState();
                $('.uc-menu-wrapper, ul.level2.uc-submenu', $menu)
                  .off('transitionend webkitTransitionEnd oTransitionEnd');
              }
            });
          // Reset menu to trigger the close animations.
          $hamburger.removeClass('uc-mobile-menu-open');
          $('ul.level2.uc-submenu', $menu).height(0);
        }
        else {
          $('.uc-menu-wrapper', $menu).addClass('uc-menu-toggle');
          $('.uc-menu-wrapper, ul.level2.uc-submenu', $menu)
            .on('transitionend webkitTransitionEnd oTransitionEnd', function (event) {
              if (event.target === event.currentTarget) {
                $('.uc-menu-wrapper', $menu).removeClass('uc-menu-toggle');
                $('.uc-menu-wrapper, ul.level2.uc-submenu', $menu)
                  .off('transitionend webkitTransitionEnd oTransitionEnd');
              }
            });
          // Initialize open animations.
          $hamburger.addClass('uc-menu-open uc-mobile-menu-open uc-desktop-menu-open');
        }
      });

      //
      // Auto-close menu.
      //
      $(document).on('mousedown focusin', function (event) {
        if (isMenuOpen()) {
          // Clicking somewhere outside of this object makes the menu close...
          var container = $menu;
          // ...If the target of the event isn't the container itself
          // ...Nor a descendant of the container
          if (!container.is(event.target) && container.has(event.target).length === 0) {
            $hamburger.trigger('click'); // Initiate close animation.
          }
        }
      });

      $(window).on('resize', function (event) {
        // Grab the dropdown height and trigger desktop dropdown menu animation.
        var $openMenu = $('ul.level2.uc-submenu[class*="uc-active-"]', $menu);
        updateDropdownHeight($openMenu);
      });

      //
      // If an advertising menu block is specified, we expect it
      // to be the last child in the list... Otherwise, move it.
      //
      $('li.menu-block-item', $menu).not(':last-child').each(function () {
        $(this).appendTo($(this).parent());
      });

      //
      // Mark the path up from the user's current page location. This is
      // useful for adjusting the mobile menu display when first opened.
      // (The 'current' class is a little too generic for this use-case)
      // (The 'is-active' class gets set later so dig down to last link)
      //
      $('li.current > a', $menu).last().closest('ul').addClass('uc-current-link-submenu')
        .parent('li').addClass('uc-current-link')
        .parents('ul, li').addClass('uc-current-path');
    }
  };

})(jQuery, Drupal);
